<template lang='pug'>
  i.svg-icon.svg-icon-write
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M92.381,54.171c-3.42-3.452-7.942-5.554-12.742-5.998c4.144-3.728,6.756-9.108,6.756-15.119 c0-11.246-9.111-20.358-20.357-20.358c-10.742,0-19.536,8.322-20.3,18.865C55.292,35.696,62,45.219,62,56.277 c0,4.037-0.919,7.982-2.627,11.564c2.46,1.285,4.728,2.947,6.706,4.942c5.069,5.104,7.951,12.162,7.896,19.357l-0.005,0.147 l-0.004,0.124l-0.18,3.406h24.387l0.201-26.967C98.414,63.349,96.262,58.072,92.381,54.171z M48.684,71.399 c4.139-3.726,6.762-9.107,6.762-15.118c0-11.249-9.116-20.363-20.362-20.363s-20.36,9.114-20.36,20.363 c0,6,2.612,11.378,6.745,15.103C10.883,72.203,2.521,80.973,2.444,91.766l-0.201,4.054H33.2h34.019l0.2-3.75 c0.04-5.498-2.116-10.774-5.996-14.679C58,73.938,53.479,71.842,48.684,71.399z M15.279,24.982v6.248 c0,2.589,2.102,4.688,4.694,4.688c2.591,0,4.692-2.1,4.692-4.688v-6.248h6.241c2.587,0,4.688-2.103,4.688-4.692 s-2.101-4.689-4.688-4.689h-6.241V9.444c0-2.59-2.102-4.688-4.692-4.688c-2.592,0-4.694,2.098-4.694,4.688v6.155H9.124 c-2.596,0-4.693,2.102-4.693,4.689c0,2.589,2.097,4.692,4.693,4.692h6.155V24.982z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>